import React from "react";
import { useFormContext } from "react-hook-form";
import { PrimaryButton } from "../Buttons";
import { useFormCtx } from "./Form";

/**
 * Submit button that picks up form state automatically — disables itself
 * while the form is submitting (or while it's invalid, if `disableWhenInvalid`).
 * Use the `loadingLabel` prop to override "Saving..." for non-save actions.
 *
 * Renders a right-aligned action row by default — suitable for modals and
 * inline forms. Set `block` for a full-width button instead (auth pages,
 * single-CTA layouts).
 *
 * Pair with a Cancel button via the `secondary` prop, or wrap multiple
 * actions yourself.
 */
const FormSubmit = ({
  children = "Save",
  loadingLabel = "Saving...",
  disableWhenInvalid = false,
  secondary,
  block = false,
  className = "",
}) => {
  const { formState } = useFormContext();
  const { submitting } = useFormCtx();
  const disabled = submitting || (disableWhenInvalid && !formState.isValid);

  if (block) {
    return (
      <PrimaryButton
        type="submit"
        disabled={disabled}
        className={`w-full justify-center ${className}`}
      >
        {submitting ? loadingLabel : children}
      </PrimaryButton>
    );
  }

  return (
    <div className={`flex justify-end gap-3 pt-2 ${className}`}>
      {secondary}
      <PrimaryButton type="submit" disabled={disabled}>
        {submitting ? loadingLabel : children}
      </PrimaryButton>
    </div>
  );
};

export default FormSubmit;
